"use client";

import { c as _c } from "react/compiler-runtime";
import { FormControl, MenuItem, Select } from "@mui/material";
import Image from "next/image";
import React, { useState } from "react";
import { Checkbox, Text, TextColor, TextSize, TextWeight } from "../../../components";
import { parseProductName } from "../../../utils";

// Skeleton komponent dla ładowania
export const ProductToReturnListItemSkeleton = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-full h-[200px] bg-gray-200 mb-4 rounded" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex-1 flex flex-col gap-1"><div className="h-5 bg-gray-200 rounded w-3/4" /><div className="h-4 bg-gray-200 rounded w-1/3" /><div className="h-4 bg-gray-200 rounded w-1/4" /><div className="h-4 bg-gray-200 rounded w-1/2" /><div className="h-4 bg-gray-200 rounded w-2/3 mt-2" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col sm:hidden">{t0}<div className="flex flex-col gap-4">{t1}<div className="flex justify-between items-end"><div className="text-right flex-1"><div className="h-5 bg-gray-200 rounded w-32 mb-1" /><div className="h-4 bg-gray-200 rounded w-8" /></div></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="w-[90px] h-[135px] bg-gray-200 flex-shrink-0 rounded" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex-1 flex flex-col gap-1"><div className="h-5 bg-gray-200 rounded w-3/4" /><div className="h-4 bg-gray-200 rounded w-1/3" /><div className="h-4 bg-gray-200 rounded w-1/4" /><div className="h-4 bg-gray-200 rounded w-1/2" /><div className="h-4 bg-gray-200 rounded w-2/3 mt-2" /></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="p-4 bg-white border border-gray-100 animate-pulse">{t2}<div className="hidden sm:flex items-start gap-4">{t3}{t4}<div className="flex flex-col items-end gap-4"><div className="text-right flex gap-2"><div className="h-5 bg-gray-200 rounded w-24" /><div className="h-5 bg-gray-200 rounded w-8" /></div></div></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
// Komponent dla pojedynczego produktu
export const ProductToReturnListItem = t0 => {
  const $ = _c(151);
  const {
    product,
    selectedProducts,
    setSelectedProducts,
    reasons,
    isStepCompleted: t1
  } = t0;
  const isStepCompleted = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== product.productName) {
    t2 = parseProductName(product.productName);
    $[0] = product.productName;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    name,
    size,
    color
  } = t2;
  let t3;
  if ($[2] !== color || $[3] !== name || $[4] !== product || $[5] !== size) {
    t3 = {
      ...product,
      name,
      size,
      color
    };
    $[2] = color;
    $[3] = name;
    $[4] = product;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const extendedProduct = t3;
  const [imageError, setImageError] = useState(false);
  let t4;
  if ($[7] !== product.idOrderDetail || $[8] !== selectedProducts) {
    let t5;
    if ($[10] !== product.idOrderDetail) {
      t5 = p => p.idOrderDetail === product.idOrderDetail;
      $[10] = product.idOrderDetail;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t4 = selectedProducts.find(t5);
    $[7] = product.idOrderDetail;
    $[8] = selectedProducts;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const selectedProduct = t4;
  let t5;
  if ($[12] !== product.idOrderDetail || $[13] !== product.productQuantity || $[14] !== selectedProducts || $[15] !== setSelectedProducts) {
    t5 = newQuantity => {
      if (newQuantity < 0 || newQuantity > product.productQuantity) {
        return;
      }
      setSelectedProducts(selectedProducts.map(p_0 => p_0.idOrderDetail === product.idOrderDetail ? {
        ...p_0,
        returnQuantity: newQuantity.toString()
      } : p_0));
    };
    $[12] = product.idOrderDetail;
    $[13] = product.productQuantity;
    $[14] = selectedProducts;
    $[15] = setSelectedProducts;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const handleQuantityChange = t5;
  let t6;
  if ($[17] !== product || $[18] !== selectedProduct || $[19] !== selectedProducts || $[20] !== setSelectedProducts) {
    t6 = () => {
      if (selectedProduct) {
        setSelectedProducts(selectedProducts.filter(p_1 => p_1.idOrderDetail !== product.idOrderDetail));
      } else {
        setSelectedProducts([...selectedProducts, {
          ...product,
          returnQuantity: "0",
          returnReason: ""
        }]);
      }
    };
    $[17] = product;
    $[18] = selectedProduct;
    $[19] = selectedProducts;
    $[20] = setSelectedProducts;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const handleCheckboxChange = t6;
  let t7;
  if ($[22] !== product.idOrderDetail || $[23] !== selectedProducts || $[24] !== setSelectedProducts) {
    t7 = reasonId => {
      setSelectedProducts(selectedProducts.map(p_2 => p_2.idOrderDetail === product.idOrderDetail ? {
        ...p_2,
        returnReason: reasonId
      } : p_2));
    };
    $[22] = product.idOrderDetail;
    $[23] = selectedProducts;
    $[24] = setSelectedProducts;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  const handleReasonChange = t7;
  const getProductImageUrl = _temp;
  let t8;
  if ($[26] !== product) {
    t8 = getProductImageUrl(product);
    $[26] = product;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  const imageUrl = t8;
  let t9;
  if ($[28] !== extendedProduct.name || $[29] !== imageError || $[30] !== imageUrl) {
    t9 = <div className="w-full h-[200px] bg-gray-100 flex items-center justify-center mb-4">{imageUrl && !imageError ? <Image src={imageUrl} alt={extendedProduct.name || "Produkt"} width={200} height={200} className="object-cover max-h-full max-w-full" onError={() => setImageError(true)} placeholder="blur" blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAhEAACAQMDBQAAAAAAAAAAAAABAgMABAUGIWGRkqGx0f/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAGhEAAgIDAAAAAAAAAAAAAAAAAAECEgMRkf/aAAwDAQACEQMRAD8AltJagyeH0AthI5xdrLcNM91BF5pX2HaH9bcfaSXWGaRmknyJckliyjqTzSlT54b6bk+h0R//2Q==" /> : <span className="text-gray-400 text-lg text-center">IMG</span>}</div>;
    $[28] = extendedProduct.name;
    $[29] = imageError;
    $[30] = imageUrl;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== extendedProduct.name) {
    t10 = <Text text={extendedProduct.name} fontSize={TextSize.M} weight={TextWeight.MEDIUM} />;
    $[32] = extendedProduct.name;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== extendedProduct.size) {
    t11 = extendedProduct.size && <Text text={`Rozmiar: ${extendedProduct.size}`} fontSize={TextSize.S} />;
    $[34] = extendedProduct.size;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== extendedProduct.color) {
    t12 = extendedProduct.color && <Text text={`Kolor: ${extendedProduct.color}`} fontSize={TextSize.S} />;
    $[36] = extendedProduct.color;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  const t13 = `Indeks: ${extendedProduct.productReference}`;
  let t14;
  if ($[38] !== t13) {
    t14 = <Text text={t13} fontSize={TextSize.S} />;
    $[38] = t13;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== handleReasonChange || $[41] !== isStepCompleted || $[42] !== product.idOrderDetail || $[43] !== reasons || $[44] !== selectedProduct) {
    t15 = selectedProduct && <div className="mt-2"><Text text={"Pow\xF3d zwrotu:"} fontSize={TextSize.S} color={TextColor.GRAYSCALE_600} /><FormControl variant="standard" sx={{
        minWidth: 200
      }}><Select labelId={`reason-label-mobile-${product.idOrderDetail}`} value={selectedProduct.returnReason || ""} onChange={e => handleReasonChange(e.target.value)} disabled={isStepCompleted}>{reasons.map(_temp2)}</Select></FormControl></div>;
    $[40] = handleReasonChange;
    $[41] = isStepCompleted;
    $[42] = product.idOrderDetail;
    $[43] = reasons;
    $[44] = selectedProduct;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== t10 || $[47] !== t11 || $[48] !== t12 || $[49] !== t14 || $[50] !== t15) {
    t16 = <div className="flex-1 flex flex-col gap-1">{t10}{t11}{t12}{t14}{t15}</div>;
    $[46] = t10;
    $[47] = t11;
    $[48] = t12;
    $[49] = t14;
    $[50] = t15;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  let t17;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Text text={"Zwr\xF3cona ilo\u015B\u0107:"} />;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== handleQuantityChange || $[54] !== isStepCompleted || $[55] !== product.productQuantity || $[56] !== selectedProduct) {
    t18 = selectedProduct && <div className="flex items-center justify-end gap-2 mt-1"><div className="flex items-center gap-2 bg-gray-50 rounded-lg px-2 py-1"><button onClick={() => handleQuantityChange(Number(selectedProduct.returnQuantity) - 1)} className={`w-6 h-6 flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded ${Number(selectedProduct.returnQuantity) <= 0 ? "opacity-50 cursor-not-allowed" : ""}`} disabled={Number(selectedProduct.returnQuantity) <= 0 || isStepCompleted}>-</button><span className="min-w-[20px] text-center text-sm font-bold">{selectedProduct.returnQuantity}</span><button onClick={() => handleQuantityChange(Number(selectedProduct.returnQuantity) + 1)} className={`w-6 h-6 flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded ${Number(selectedProduct.returnQuantity) >= product.productQuantity ? "opacity-50 cursor-not-allowed" : ""}`} disabled={Number(selectedProduct.returnQuantity) >= product.productQuantity || isStepCompleted}>+</button></div><Text text={`/${product.productQuantity}`} fontSize={TextSize.L} weight={TextWeight.BOLD} /></div>;
    $[53] = handleQuantityChange;
    $[54] = isStepCompleted;
    $[55] = product.productQuantity;
    $[56] = selectedProduct;
    $[57] = t18;
  } else {
    t18 = $[57];
  }
  let t19;
  if ($[58] !== t18) {
    t19 = <div className="flex justify-between items-end"><div className="text-right flex-1">{t17}{t18}</div></div>;
    $[58] = t18;
    $[59] = t19;
  } else {
    t19 = $[59];
  }
  let t20;
  if ($[60] !== t16 || $[61] !== t19) {
    t20 = <div className="flex flex-col gap-4">{t16}{t19}</div>;
    $[60] = t16;
    $[61] = t19;
    $[62] = t20;
  } else {
    t20 = $[62];
  }
  let t21;
  if ($[63] !== t20 || $[64] !== t9) {
    t21 = <div className="flex flex-col sm:hidden">{t9}{t20}</div>;
    $[63] = t20;
    $[64] = t9;
    $[65] = t21;
  } else {
    t21 = $[65];
  }
  const t22 = !!selectedProduct;
  let t23;
  if ($[66] !== handleCheckboxChange || $[67] !== isStepCompleted || $[68] !== product.idOrderDetail || $[69] !== t22) {
    t23 = <div className="self-center"><Checkbox id={product.idOrderDetail} name={product.idOrderDetail} label="" checked={t22} onChange={handleCheckboxChange} disabled={isStepCompleted} /></div>;
    $[66] = handleCheckboxChange;
    $[67] = isStepCompleted;
    $[68] = product.idOrderDetail;
    $[69] = t22;
    $[70] = t23;
  } else {
    t23 = $[70];
  }
  let t24;
  if ($[71] !== extendedProduct.name || $[72] !== imageError || $[73] !== imageUrl) {
    t24 = <div className="w-[90px] h-[135px] bg-gray-100 flex-shrink-0 flex items-center justify-center">{imageUrl && !imageError ? <Image src={imageUrl} alt={extendedProduct.name || "Produkt"} width={90} height={135} className="object-cover" onError={() => setImageError(true)} placeholder="blur" blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAhEAACAQMDBQAAAAAAAAAAAAABAgMABAUGIWGRkqGx0f/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAGhEAAgIDAAAAAAAAAAAAAAAAAAECEgMRkf/aAAwDAQACEQMRAD8AltJagyeH0AthI5xdrLcNM91BF5pX2HaH9bcfaSXWGaRmknyJckliyjqTzSlT54b6bk+h0R//2Q==" /> : <span className="text-gray-400 text-xs text-center">IMG</span>}</div>;
    $[71] = extendedProduct.name;
    $[72] = imageError;
    $[73] = imageUrl;
    $[74] = t24;
  } else {
    t24 = $[74];
  }
  let t25;
  if ($[75] !== extendedProduct.name) {
    t25 = <Text text={extendedProduct.name} fontSize={TextSize.M} weight={TextWeight.MEDIUM} />;
    $[75] = extendedProduct.name;
    $[76] = t25;
  } else {
    t25 = $[76];
  }
  let t26;
  if ($[77] !== extendedProduct.size) {
    t26 = extendedProduct.size && <Text text={`Rozmiar: ${extendedProduct.size}`} fontSize={TextSize.S} />;
    $[77] = extendedProduct.size;
    $[78] = t26;
  } else {
    t26 = $[78];
  }
  let t27;
  if ($[79] !== extendedProduct.color) {
    t27 = extendedProduct.color && <Text text={`Kolor: ${extendedProduct.color}`} fontSize={TextSize.S} />;
    $[79] = extendedProduct.color;
    $[80] = t27;
  } else {
    t27 = $[80];
  }
  const t28 = `Indeks: ${extendedProduct.productReference}`;
  let t29;
  if ($[81] !== t28) {
    t29 = <Text text={t28} fontSize={TextSize.S} />;
    $[81] = t28;
    $[82] = t29;
  } else {
    t29 = $[82];
  }
  const t30 = `Cena: ${extendedProduct.price} zł`;
  let t31;
  if ($[83] !== t30) {
    t31 = <Text text={t30} fontSize={TextSize.S} />;
    $[83] = t30;
    $[84] = t31;
  } else {
    t31 = $[84];
  }
  let t32;
  if ($[85] !== extendedProduct.price || $[86] !== extendedProduct.total) {
    t32 = Number(extendedProduct.price) !== Number(extendedProduct.total) && <Text text={`Razem: ${extendedProduct.total} zł`} fontSize={TextSize.S} />;
    $[85] = extendedProduct.price;
    $[86] = extendedProduct.total;
    $[87] = t32;
  } else {
    t32 = $[87];
  }
  let t33;
  if ($[88] !== t31 || $[89] !== t32) {
    t33 = <div className="mt-2 flex flex-col gap-1 pt-2">{t31}{t32}</div>;
    $[88] = t31;
    $[89] = t32;
    $[90] = t33;
  } else {
    t33 = $[90];
  }
  let t34;
  if ($[91] !== t25 || $[92] !== t26 || $[93] !== t27 || $[94] !== t29 || $[95] !== t33) {
    t34 = <div className="flex-1 flex flex-col gap-1">{t25}{t26}{t27}{t29}{t33}</div>;
    $[91] = t25;
    $[92] = t26;
    $[93] = t27;
    $[94] = t29;
    $[95] = t33;
    $[96] = t34;
  } else {
    t34 = $[96];
  }
  let t35;
  if ($[97] !== product.qtyReturned) {
    t35 = Number(product.qtyReturned) > 0 && <div className="text-right flex gap-2 items-center"><Text text={`Zwrócono: ${product.qtyReturned}`} /></div>;
    $[97] = product.qtyReturned;
    $[98] = t35;
  } else {
    t35 = $[98];
  }
  let t36;
  if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <Text text={"Pow\xF3d zwrotu:"} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_400} />;
    $[99] = t36;
  } else {
    t36 = $[99];
  }
  let t37;
  if ($[100] !== handleQuantityChange || $[101] !== selectedProduct?.returnQuantity) {
    t37 = () => handleQuantityChange(Number(selectedProduct?.returnQuantity || 0) - 1);
    $[100] = handleQuantityChange;
    $[101] = selectedProduct?.returnQuantity;
    $[102] = t37;
  } else {
    t37 = $[102];
  }
  const t38 = `w-6 h-6 flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded ${Number(selectedProduct?.returnQuantity || 0) <= 0 || !selectedProduct ? "opacity-50 cursor-not-allowed" : ""}`;
  const t39 = Number(selectedProduct?.returnQuantity || 0) <= 0 || isStepCompleted || !selectedProduct;
  let t40;
  if ($[103] !== t37 || $[104] !== t38 || $[105] !== t39) {
    t40 = <button onClick={t37} className={t38} disabled={t39}>-</button>;
    $[103] = t37;
    $[104] = t38;
    $[105] = t39;
    $[106] = t40;
  } else {
    t40 = $[106];
  }
  const t41 = selectedProduct?.returnQuantity || 0;
  let t42;
  if ($[107] !== t41) {
    t42 = <span className="min-w-[20px] text-center text-sm font-bold">{t41}</span>;
    $[107] = t41;
    $[108] = t42;
  } else {
    t42 = $[108];
  }
  let t43;
  if ($[109] !== handleQuantityChange || $[110] !== selectedProduct?.returnQuantity) {
    t43 = () => handleQuantityChange(Number(selectedProduct?.returnQuantity || 0) + 1);
    $[109] = handleQuantityChange;
    $[110] = selectedProduct?.returnQuantity;
    $[111] = t43;
  } else {
    t43 = $[111];
  }
  const t44 = `w-6 h-6 flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded ${Number(selectedProduct?.returnQuantity || 0) >= product.productQuantity || !selectedProduct ? "opacity-50 cursor-not-allowed" : ""}`;
  const t45 = Number(selectedProduct?.returnQuantity || 0) >= product.productQuantity || isStepCompleted || !selectedProduct;
  let t46;
  if ($[112] !== t43 || $[113] !== t44 || $[114] !== t45) {
    t46 = <button onClick={t43} className={t44} disabled={t45}>+</button>;
    $[112] = t43;
    $[113] = t44;
    $[114] = t45;
    $[115] = t46;
  } else {
    t46 = $[115];
  }
  let t47;
  if ($[116] !== t40 || $[117] !== t42 || $[118] !== t46) {
    t47 = <div className="flex items-center gap-2 bg-gray-50 rounded-lg px-2 py-1">{t40}{t42}{t46}</div>;
    $[116] = t40;
    $[117] = t42;
    $[118] = t46;
    $[119] = t47;
  } else {
    t47 = $[119];
  }
  const t48 = `/${product.productQuantity}`;
  let t49;
  if ($[120] !== t48) {
    t49 = <Text text={t48} fontSize={TextSize.L} weight={TextWeight.BOLD} />;
    $[120] = t48;
    $[121] = t49;
  } else {
    t49 = $[121];
  }
  let t50;
  if ($[122] !== t47 || $[123] !== t49) {
    t50 = <div className="flex flex-col gap-2 min-w-[200px]">{t36}<div className="flex items-center gap-2">{t47}{t49}</div></div>;
    $[122] = t47;
    $[123] = t49;
    $[124] = t50;
  } else {
    t50 = $[124];
  }
  let t51;
  let t52;
  if ($[125] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = {
      minWidth: 200
    };
    t52 = <Text text={"Pow\xF3d zwrotu:"} fontSize={TextSize.XS} color={TextColor.GRAYSCALE_400} />;
    $[125] = t51;
    $[126] = t52;
  } else {
    t51 = $[125];
    t52 = $[126];
  }
  const t53 = `reason-label-${product.idOrderDetail}`;
  const t54 = selectedProduct?.returnReason || "";
  let t55;
  if ($[127] !== handleReasonChange) {
    t55 = e_0 => handleReasonChange(e_0.target.value);
    $[127] = handleReasonChange;
    $[128] = t55;
  } else {
    t55 = $[128];
  }
  const t56 = isStepCompleted || !selectedProduct;
  let t57;
  if ($[129] !== reasons) {
    t57 = reasons.map(_temp3);
    $[129] = reasons;
    $[130] = t57;
  } else {
    t57 = $[130];
  }
  let t58;
  if ($[131] !== t53 || $[132] !== t54 || $[133] !== t55 || $[134] !== t56 || $[135] !== t57) {
    t58 = <div className="flex gap-2 items-center"><FormControl variant="standard" sx={t51}>{t52}<Select labelId={t53} value={t54} onChange={t55} disabled={t56}>{t57}</Select></FormControl></div>;
    $[131] = t53;
    $[132] = t54;
    $[133] = t55;
    $[134] = t56;
    $[135] = t57;
    $[136] = t58;
  } else {
    t58 = $[136];
  }
  let t59;
  if ($[137] !== t50 || $[138] !== t58) {
    t59 = <>{t50}{t58}</>;
    $[137] = t50;
    $[138] = t58;
    $[139] = t59;
  } else {
    t59 = $[139];
  }
  let t60;
  if ($[140] !== t35 || $[141] !== t59) {
    t60 = <div className="flex flex-col items-end gap-2">{t35}{t59}</div>;
    $[140] = t35;
    $[141] = t59;
    $[142] = t60;
  } else {
    t60 = $[142];
  }
  let t61;
  if ($[143] !== t23 || $[144] !== t24 || $[145] !== t34 || $[146] !== t60) {
    t61 = <div className="hidden sm:flex items-start gap-4">{t23}{t24}{t34}{t60}</div>;
    $[143] = t23;
    $[144] = t24;
    $[145] = t34;
    $[146] = t60;
    $[147] = t61;
  } else {
    t61 = $[147];
  }
  let t62;
  if ($[148] !== t21 || $[149] !== t61) {
    t62 = <div className="p-4 bg-white border border-gray-100 relative">{t21}{t61}</div>;
    $[148] = t21;
    $[149] = t61;
    $[150] = t62;
  } else {
    t62 = $[150];
  }
  return t62;
};
function _temp(product_0) {
  if (product_0.cover) {
    return product_0.cover.replace("http://localhost/prestashop", "https://shop.carry.pl").replace("carry-prestashop.ulam.tech", "shop.carry.pl");
  }
  return null;
}
function _temp2(reason) {
  return <MenuItem key={reason.idReturnReason} value={reason.idReturnReason}>{reason.title}</MenuItem>;
}
function _temp3(reason_0) {
  return <MenuItem key={reason_0.idReturnReason} value={reason_0.idReturnReason}>{reason_0.title}</MenuItem>;
}